module.exports = __webpack_public_path__ + "static/img/xfxb5.72200a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/xfxb5.jpg
// module id = so3g
// module chunks = 0